import React from "react";
import { useNavigate } from "react-router-dom"; // Import navigation hook
import "./Communitytabsroom.css";

const CommunityTabsRoom = () => {
  const navigate = useNavigate(); // Initialize navigation

  return (
    <section className="communityTabsRoom">
      {/* Tabs Section */}
      <nav className="communityTabsRoom-tabs">
        <button
          className="communityTabsRoom-tab"
          onClick={() => navigate("/lists")} // Navigate to CommunityLists page
        >
          Lists
        </button>
        <button
          className="communityTabsRoom-tab"
          onClick={() => navigate("/favourites")} // Navigate to CommunityFavourites page
        >
          Favourites
        </button>
        <button
          className="communityTabsRoom-tab"
          onClick={() => navigate("/community")} // Navigate to CommunityPage (Chat Room)
        >
          Chat Room
        </button>
        <button
          className="communityTabsRoom-tab"
          onClick={() => navigate("/members")} // Navigate to CommunityMember page
        >
          Members
        </button>
      </nav>

      {/* Toggles Section */}
      <div className="communityTabsRoom-toggles">
        <div className="communityTabsRoom-toggle-item">
          <p className="communityTabsRoom-toggle-text">Guest comments on</p>
          <div className="communityTabsRoom-toggle green"></div>
        </div>
        <div className="communityTabsRoom-toggle-item">
          <p className="communityTabsRoom-toggle-text">Guest comments off</p>
          <div className="communityTabsRoom-toggle red"></div>
        </div>
      </div>
    </section>
  );
};

export default CommunityTabsRoom;
